// Import Swiper and modules
import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, Thumbs, Autoplay, Scrollbar, Grid } from 'swiper/modules';

class BuilttSwiper extends HTMLElement {
  constructor() {
    super();
    this.thumbsSwiper = null

    this.settings = {
      slidesPerView: 1.85,
      spaceBetween: 20,
      effect: "drag",
      watchSlidesProgress: true,
      sliderCustomCounter: true,
      navigation: {
        nextEl: ".btt-swiper-button-next",
        prevEl: ".btt-swiper-button-prev"
      },
      customScrollBar: true,
      breakpoints: {
        991: {
          slidesPerView: 4.18
        },
        1640: {
          slidesPerView: 5.18
        }
      }
    }

    if (this.querySelector('[swiper-settings-thumbs]') !== null) {
      this.thumbsSettings = JSON.parse(this.querySelector('[swiper-settings-thumbs]').textContent)

      const finalThumbsSwiperOptions = Object.assign({}, this.thumbsSettings, {
        modules: [Thumbs],
      })

      const thumbs = this.querySelector('.swiper-thumbnails')
      this.thumbsSwiper = new Swiper(thumbs, finalThumbsSwiperOptions)
    }
    var thumbnailsSlider = this.thumbsSwiper
    
    if (this.querySelector('[swiper-settings-main]') !== null) {
      this.settings = JSON.parse(
        this.querySelector('[swiper-settings-main]').textContent
      )
    }

    if (this.settings.sliderCustomCounter) {
      if (window.innerWidth < 800) {
        this.slidesPerView = this.settings.slidesPerView && Math.floor(this.settings.slidesPerView) - 1
      } else if (window.innerWidth > 800 && window.innerWidth < 991 && this.settings.breakpoints[800]) {
        this.slidesPerView = this.settings.breakpoints[800].slidesPerView && Math.floor(this.settings.breakpoints[800].slidesPerView) - 1
      } else if (window.innerWidth >= 991 && window.innerWidth < 1440 && this.settings.breakpoints[991]) {
        this.slidesPerView = this.settings.breakpoints[991].slidesPerView && Math.floor(this.settings.breakpoints[991].slidesPerView) - 1
      } else if (window.innerWidth >= 1440 && this.settings.breakpoints[1440]) {
        this.slidesPerView = this.settings.breakpoints[1440].slidesPerView && Math.floor(this.settings.breakpoints[1440].slidesPerView) - 1
      } else if (window.innerWidth >= 1640 && this.settings.breakpoints[1640]) {
        this.slidesPerView = this.settings.breakpoints[1640].slidesPerView && Math.floor(this.settings.breakpoints[1640].slidesPerView) - 1
      } else {
        this.slidesPerView = this.settings.breakpoints[991].slidesPerView && Math.floor(this.settings.breakpoints[991].slidesPerView) - 1
      }
      this.totalSlides = this.settings.sliderItemLength
    }

    const finalSwiperOptions = Object.assign({}, this.settings, {
      modules: [Navigation, Pagination, EffectFade, Thumbs, Autoplay, Scrollbar, Grid],
      thumbs: {
        swiper: this.thumbsSwiper && this.thumbsSwiper
      },
      pagination: this.settings.sliderCustomCounter ? {
        el: ".swiper-pagination",
        type: "custom",
        renderCustom: (swiper, current, total) => this.renderCustomPagination(swiper, current, total, this.slidesPerView)
      } : this.settings.normalPagination ? { el: ".swiper-pagination" } : false,    
    })

    const el = this.querySelector('.swiper-carousel')

    if (!finalSwiperOptions.mobileDisabled) {
      const mainSwiper = new Swiper(el, finalSwiperOptions)
      thumbnailsSlider && this.syncSliders(mainSwiper, thumbnailsSlider)
    } else if (finalSwiperOptions.mobileDisabled && window.innerWidth > 991) {
      const mainSwiper = new Swiper(el, finalSwiperOptions)
      thumbnailsSlider && this.syncSliders(mainSwiper, thumbnailsSlider)
    }
  }

  syncSliders(first_slider, second_slider) {
    const sliders = [first_slider, second_slider]
    sliders.forEach((slider, index) => {
      let sliderToSync = index < sliders.length - 1 ? index + 1 : 0
      slider && slider.on('slideChange', () => this.syncASlider(sliders[index], sliders[sliderToSync]))
    })
  }

  syncASlider(first_slider, second_slider) {
    let activeIndex = first_slider?.activeIndex;
    second_slider && second_slider.slideTo(activeIndex);
  }

  renderCustomPagination(swiper, current, total, extraValue) {
    return `<span class="custom-pagination text-[0.8125rem] leading-[1.0625rem]">${current + extraValue}/${total + extraValue}</span>`;
  }
}

customElements.define('builtt-swiper', BuilttSwiper)
